
import { defineComponent, reactive, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'

import UploadDialog from './_components/upload-dialog/upload-dialog.vue'
import { ElMessage } from 'element-plus'
import {
  TASK_STATUS_OPTIONS, TaskStatus,
  VersionUpdateService
} from '@/views/dashboard/setting/version-update/version-update.service'
import { getBaseUrl } from '@/common/const/api-base-url'
import { IS_PRIVATE } from '@/common/const/env'
import CurrentVersion from '@/views/dashboard/setting/version-update/_components/current-version/current-version.vue'
import CascadeSetting from '@/views/dashboard/setting/version-update/_components/cascade-setting/cascade-setting.vue'

export default defineComponent({
  name: 'VersionUpdate',
  components: {
    CascadeSetting,
    UploadDialog,
    CurrentVersion,
  },
  setup () {
    const injector = useReflectiveInjector([VersionUpdateService])
    const versionUpdateService = injector.get(VersionUpdateService)
    const uploadNode = ref()
    let statusTimer: any = null

    const viewModel = reactive({
      uploadDialog: false,
      uploading: 0,
      uploadFile: null,
      errorMsg: '',
      fileName: '',
      percentage: 0,
      taskStatus: {} as TaskStatus
    })
    function resetFormData () {
      uploadNode.value.clearFiles()
      viewModel.fileName = ''
      viewModel.uploadFile = null
      viewModel.percentage = 0
    }

    function showUploadDialog () {
      viewModel.uploadDialog = true
      viewModel.uploading = TASK_STATUS_OPTIONS.RUNNING
    }

    function getStatus () {
      versionUpdateService.getUpgradeStatus().then(response => {
        if (response.task_status === TASK_STATUS_OPTIONS.RUNNING) {
          clearTimeout(statusTimer)
          statusTimer = setTimeout(() => {
            getStatus()
            // eslint-disable-next-line no-magic-numbers
          }, 4000)
        }
        delete response.resp_common
        viewModel.taskStatus = response
      })
    }

    getStatus()
    return {
      IS_PRIVATE,
      TASK_STATUS_OPTIONS,
      uploadNode,
      viewModel,
      getBaseUrl,
      uploadDone () {
        resetFormData()
        viewModel.uploadDialog = false
        getStatus()
        if (viewModel.uploading === TASK_STATUS_OPTIONS.SUCCESS) {
          ElMessage.warning('升级包正在更新中，请稍等。')
        }
      },
      resetUpload () {
        viewModel.uploadDialog = false
        resetFormData()
      },
      handleHttpUpload () {
        const data = new FormData()
        data.append('file', viewModel.uploadFile?.raw)
        showUploadDialog()
        versionUpdateService.upgradeUpload(data, (progress: any) => {
          // eslint-disable-next-line no-magic-numbers
          viewModel.percentage = Math.floor((progress.loaded / progress.total) * 100)
        }).then(response => {
          if (response.resp_common?.ret) {
            viewModel.uploading = TASK_STATUS_OPTIONS.FAIL
            return
          }

          viewModel.uploading = TASK_STATUS_OPTIONS.SUCCESS
          getStatus()
        }).catch(() => {
          viewModel.uploading = TASK_STATUS_OPTIONS.FAIL
          viewModel.errorMsg = '上传更新文件失败'
        })
      },
      handleSubmitUpload () {
        uploadNode.value.submit()
      },
      handleClick () {
        resetFormData()
      },
      handleChange (file: any) {
        if (file?.status === 'ready') {
          viewModel.uploadFile = file
          viewModel.fileName = file.name
          viewModel.percentage = 0
        }
      },
    }
  }
})
